import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export const useStoreAuthV2 = create(
  persist(
    (set, get) => ({
      prospectId: null,
      identifier: "",
      identifierType: "",
      isNewUser: false,
      needsPassword: false,
      isReturningUser: false,

      otpSent: false,
      canResendAt: null,
      otpExpiration: null,
      otpAttempts: 0,
      testOtpCode: null,

      currentStep: "entry",
      blockedUntil: null,

      recoveryMode: false,
      maskedSecondaryContact: "",
      secondaryContactType: "",

      socialLoginData: null,
      needsSecondaryContact: false,
      needsContact: false,

      formData: {
        firstname: "",
        lastname: "",
        birthdate: "",
        secondaryContact: "",
        password: "",
      },
      pendingOtpPhone: "",

      adminProspect: null,

      setProspectId: (prospectId) => set({ prospectId }),

      setIdentifier: (identifier, identifierType) =>
        set({
          identifier,
          identifierType,
        }),

      setUserType: (isNewUser, needsPassword = false) =>
        set({
          isNewUser,
          needsPassword,
        }),

      setReturningUser: (isReturningUser) =>
        set({
          isReturningUser,
        }),

      setOtpState: (otpSent, canResendAt = null, otpExpiration = null) =>
        set({
          otpSent,
          canResendAt,
          otpExpiration,
        }),

      setTestOtpCode: (code) => set({ testOtpCode: code || null }),

      setCurrentStep: (step) => set({ currentStep: step }),

      setBlocked: (blockedUntil) => set({ blockedUntil }),

      incrementOtpAttempts: () =>
        set((state) => ({
          otpAttempts: state.otpAttempts + 1,
        })),

      resetOtpAttempts: () => set({ otpAttempts: 0 }),

      setFormData: (data) =>
        set((state) => ({
          formData: { ...state.formData, ...data },
        })),

      setPendingOtpPhone: (pendingOtpPhone) => set({ pendingOtpPhone }),

      resetFormData: () =>
        set({
          formData: {
            firstname: "",
            lastname: "",
            birthdate: "",
            secondaryContact: "",
            password: "",
          },
          pendingOtpPhone: "",
        }),

      setRecoveryMode: (recoveryMode) => set({ recoveryMode }),
      setMaskedSecondaryContact: (maskedSecondaryContact) =>
        set({ maskedSecondaryContact }),
      setSecondaryContactType: (secondaryContactType) =>
        set({ secondaryContactType }),

      setSocialLoginData: (socialLoginData) => set({ socialLoginData }),
      setNeedsSecondaryContact: (needsSecondaryContact) =>
        set({ needsSecondaryContact }),
      setNeedsContact: (needsContact) => set({ needsContact }),

      setAdminProspect: (prospect) => set({ adminProspect: prospect }),

      resetAuthV2State: () =>
        set({
          prospectId: null,
          identifier: "",
          identifierType: "",
          isNewUser: false,
          needsPassword: false,
          isReturningUser: false,
          otpSent: false,
          canResendAt: null,
          otpExpiration: null,
          otpAttempts: 0,
          testOtpCode: null,
          currentStep: "entry",
          blockedUntil: null,
          recoveryMode: false,
          maskedSecondaryContact: "",
          secondaryContactType: "",
          socialLoginData: null,
          needsSecondaryContact: false,
          needsContact: false,
          formData: {
            firstname: "",
            lastname: "",
            birthdate: "",
            secondaryContact: "",
            password: "",
          },
          pendingOtpPhone: "",
          adminProspect: null,
        }),

      isBlocked: () => {
        const { blockedUntil } = get();
        return blockedUntil && new Date(blockedUntil) > new Date();
      },

      canResendOtp: () => {
        const { canResendAt } = get();
        return !canResendAt || new Date(canResendAt) <= new Date();
      },

      getOtpTimeLeft: () => {
        const { otpExpiration } = get();
        if (!otpExpiration) return 0;
        const diff = new Date(otpExpiration) - new Date();
        return diff > 0 ? Math.floor(diff / 1000) : 0;
      },
    }),
    {
      name: "authV2-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
